window.ShopSanteInventory = window.ShopSanteInventory || (() => {
  const requests = new Map();

  return {
    load({ productId, domain, token, query }) {
      const rawId = String(productId || "");
      const gid = rawId.startsWith("gid://shopify/Product/")
        ? rawId
        : `gid://shopify/Product/${rawId}`;

      if (!rawId || !domain || !token) return Promise.resolve(null);
      if (requests.has(gid)) return requests.get(gid);

      const request = fetch(`https://${domain}/api/2026-07/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": token,
        },
        body: JSON.stringify({ query, variables: { id: gid } }),
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok || !data?.data?.product) {
            throw new Error("Unable to load product inventory");
          }
          return data;
        })
        .catch((error) => {
          requests.delete(gid);
          throw error;
        });

      requests.set(gid, request);
      return request;
    },
  };
})();

if (typeof ProductVariants !== "function") {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.locationProduct = {};
      this.variantData = [];
      this.storeLocationName = "";
      this.productVariantSelector = this.querySelector(
        "product-variant-selector"
      );
      (async () => {
        await this.getLocation();
        await this.getStoreName();
        this.init();
      })();
      // this.init();
    }

    async init() {
      await this.getVariantData();
      this.price = this.querySelector(`#product-price-${this.dataset.id}`);
      if (this.price) {
        this.priceOriginal = this.price.querySelector(
          "[data-js-product-price-original]"
        );
        this.priceCompare = this.price.querySelector(
          "[data-js-product-price-compare]"
        );
        this.priceUnit = this.price.querySelector(
          "[data-js-product-price-unit]"
        );
        this.priceSaving = this.price.querySelector(
          "[data-js-flash-sale-saving]"
        );
      }

      this.productForm = document.querySelector(
        `#product-form-${this.dataset.id}`
      );
      if (this.productForm) {
        this.productQty = this.productForm.querySelector(
          "[data-js-product-quantity]"
        );
        this.addToCart = this.productForm.querySelector(
          "[data-js-product-add-to-cart]"
        );
        this.addToCartText = this.productForm.querySelector(
          "[data-js-product-add-to-cart-text]"
        );
      }
      this.addEventListener("change", this.onVariantChange);
      document
        .querySelectorAll("store-selector[data-main-selector]")
        .forEach((element) => {
          element.addEventListener("storechanged", (e) => {
            this.querySelectorAll(
              ".product-variant__item input.disabled"
            ).forEach((item) => item.classList.remove("disabled"));
            this.dispatchEvent(new Event("change"));
          });
        });
      window.addEventListener("load", () => {
        document
          .querySelectorAll("[data-js-select-store] [data-js-change-store]")
          .forEach((element) => {
            element.addEventListener("click", (e) => {
              this.querySelectorAll(
                ".product-variant__item input.disabled"
              ).forEach((item) => item.classList.remove("disabled"));
              this.dispatchEvent(new Event("change"));
            });
          });
      });
      window.addEventListener("load", () => {
        document
          .querySelectorAll("[data-js-reset-store]")
          .forEach((resetButton) => {
            resetButton.addEventListener("click", (e) => {
              this.querySelectorAll(
                ".product-variant__item input.disabled"
              ).forEach((item) => item.classList.remove("disabled"));
              this.dispatchEvent(new Event("change"));
            });
          });
      });

      let initVariantChange = false;
      if (this.hasAttribute("data-variant-required")) {
        this.variantRequired = true;
        this.noVariantSelectedYet = true;
        if (document.location.search.includes("variant")) {
          const initVariant = parseInt(
            new URLSearchParams(document.location.search).get("variant")
          );
          const variantData = this.variantData;

          this.currentVariant = variantData.find((variant) => {
            if (variant.id == initVariant) {
              variant.options.map((option, index) => {
                const variantContainer = this.querySelectorAll(
                  `[data-js-product-variant]`
                )[index].querySelector(`[data-js-product-variant-container]`);
                if (
                  variantContainer.dataset.jsProductVariantContainer == "radio"
                ) {
                  variantContainer.querySelector(
                    `input[value="${option}"]`
                  ).checked = true;
                } else if (
                  variantContainer.dataset.jsProductVariantContainer == "select"
                ) {
                  variantContainer.value = option;
                }
              });
              return variant;
            }
          });

          if (this.currentVariant) {
            this.variantRequired = false;
            this.noVariantSelectedYet = false;
            initVariantChange = true;
          }
        }
      } else {
        this.variantRequired = false;
        this.noVariantSelectedYet = false;
      }
      const vidEl = this.querySelector("[data-variant-id]");
      if (vidEl) {
        const variantId = Number(vidEl.getAttribute("data-variant-id"));
        this.getQuantityLocation(variantId);
      }
      this.updateOptions();
      this.updateMasterId();
      const autoSelectedAvailableVariant =
        this.selectFirstAvailableVariant();
      this.updateUnavailableVariants();
      this.checkBtnAddToCart();

      this.productStock = document.querySelector(
        `#product-${this.dataset.id} [data-js-variant-quantity]`
      );
      this.productStockProgress = document.querySelector(
        `#product-${this.dataset.id} [data-js-variant-quantity-progress]`
      );
      if (
        this.productStock &&
        document.querySelector(
          `#product-${this.dataset.id} [data-js-variant-quantity-data]`
        )
      ) {
        const inventoryDataElement = document.querySelector(
          `#product-${this.dataset.id} [data-js-variant-quantity-data]`
        );
        try {
          this.productStockData = JSON.parse(
            inventoryDataElement.dataset.inventory || inventoryDataElement.textContent || "[]"
          );
        } catch (error) {
          this.productStockData = [];
        }
      }
      this.updateStock();

      if (initVariantChange || autoSelectedAvailableVariant) {
        await this.onVariantChange();
      }
      this.updatePickupAvailabilityEachStore();

      this.dispatchEvent(new Event("INITLOCATION"));
    }
    async getLocation() {
      try {
        const token = window.KROWN.settings.storefront_api_key;
        const domain = window.KROWN.settings.store_domain;
        const productPage = this.closest("product-page");
        const productId = this.dataset.originId || productPage?.dataset.originId || productPage?.dataset.id;

        if (!productId) {
          throw new Error("Product ID is missing from the product page");
        }
        const query = `#graphql
					query Product($id: ID!) {
						product(id: $id) {
							availableForSale
							id
							title
							totalInventory
							variants(first: 250) {
								nodes {									
                  components(first: 50) {
									nodes {
											productVariant{
												id
												quantityAvailable
												storeAvailability (first: 250) {
													nodes {
														available
														location {
															id
															name
														}
														quantityAvailable
													}
												}
											}
											quantity
										}
									}
									id
									title
									availableForSale
									currentlyNotInStock
									quantityAvailable
									storeAvailability (first: 250) {
										nodes {
											available
											location {
												id
												name
											}
											quantityAvailable						
										}
									}
								}
							}
						}
					}
				`;

        const data = await window.ShopSanteInventory.load({
          productId,
          domain,
          token,
          query,
        });

        if (!data) return null;
        this.locationProduct = data;

        return this.locationProduct;
      } catch (error) {
        return null;
      }
    }
    resolveSelectedStoreName() {
      const selectedHandle = localStorage.getItem("selected-store");
      if (!selectedHandle) return "Shop Santé Inc.";

      const selectedItem = [...document.querySelectorAll(".store-selector-item[data-handle]")]
        .find((item) => item.getAttribute("data-handle") === selectedHandle);
      const selectedTitle = selectedItem?.getAttribute("data-title");
      if (selectedTitle) return selectedTitle;

      const handleize = (value) => String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
      const names = new Set();

      (this.locationProduct?.data?.product?.variants?.nodes || []).forEach((variant) => {
        (variant?.storeAvailability?.nodes || []).forEach((node) => {
          if (node?.location?.name) names.add(node.location.name);
        });
        (variant?.components?.nodes || []).forEach((component) => {
          (component?.productVariant?.storeAvailability?.nodes || []).forEach((node) => {
            if (node?.location?.name) names.add(node.location.name);
          });
        });
      });

      return [...names].find((name) => handleize(name) === selectedHandle)
        || "Shop Santé Inc.";
    }

    async getStoreName() {
      const storeName = this.resolveSelectedStoreName();
      this.storeLocationName = storeName;
      return storeName;
    }

    getInventoryPolicies() {
      const policies = this.querySelector("script[data-js-variant-inventory-policy]");
      if (!policies) return [];

      try {
        return JSON.parse(policies.textContent || "[]");
      } catch (error) {
        return [];
      }
    }

    isLinkedBundle() {
      return Boolean(this.dataset.originId || this.closest("product-page")?.dataset.originId);
    }

    getLinkedBundleQuantity() {
      const configuredQuantity = Number(
        this.dataset.quantityEachBundle
        || this.closest("product-page")?.dataset.quantityEachBundle
        || 0
      );
      if (configuredQuantity > 0) return configuredQuantity;

      const title = this.closest("product-page")?.querySelector("h1")?.textContent
        || document.title;
      const titleQuantity = Number(String(title || "").match(/(\d+)\s*[x×]/i)?.[1] || 1);
      return Math.max(1, titleQuantity);
    }

    getOriginInventoryPolicy(item) {
      const policyScript = this.querySelector("[data-js-origin-variant-inventory-policy]")
        || this.closest("product-page")?.querySelector("[data-js-origin-variant-inventory-policy]");
      if (!policyScript || !item) return "deny";

      try {
        const policies = JSON.parse(policyScript.textContent || "[]");
        if (policies.length === 1) return policies[0]?.inventory || "deny";
        return policies.find((policy) =>
          this.normalizeVariantTitle(policy.title) === this.normalizeVariantTitle(item.title)
        )?.inventory || "deny";
      } catch (error) {
        return "deny";
      }
    }

    getLinkedBundleState(item, storeName) {
      if (!item) return { available: false, quantity: 0, isBundle: true };

      if (this.getOriginInventoryPolicy(item) === "continue" || item.currentlyNotInStock) {
        return { available: true, quantity: 9999, isBundle: true };
      }

      const unitQuantity = Math.max(0, Number(item?.quantityAvailable || 0));
      const quantity = Math.floor(unitQuantity / this.getLinkedBundleQuantity());

      return {
        available: quantity > 0,
        quantity,
        isBundle: true,
      };
    }

    normalizeVariantTitle(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("fr-CA")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }

    findLocationVariant(localVariant, locationVariants = this.locationProduct?.data?.product?.variants?.nodes || []) {
      if (!localVariant) return null;

      if (this.isLinkedBundle() && locationVariants.length === 1) {
        return locationVariants[0];
      }

      if (!this.isLinkedBundle()) {
        return locationVariants.find((item) =>
          Number(item.id.split("gid://shopify/ProductVariant/")[1]) === Number(localVariant.id)
        ) || null;
      }

      const localTitles = [localVariant.title, localVariant.public_title, ...(localVariant.options || [])]
        .map((title) => this.normalizeVariantTitle(title))
        .filter(Boolean);

      return locationVariants.find((item) =>
        localTitles.includes(this.normalizeVariantTitle(item.title))
      ) || null;
    }

    getLocationState(item, storeName, inventoryPolicy) {
      const components = item?.components?.nodes || [];

      if (components.length) {
        const componentStates = components.map((component) => {
          const requiredQuantity = Math.max(1, Number(component?.quantity || 1));
          const isOnline = storeName === "Shop Santé Inc.";
          const availability = component?.productVariant?.storeAvailability?.nodes?.find(
            (node) => node?.location?.name === storeName
          );
          const quantityAvailable = Math.max(0, Number(
            isOnline
              ? availability?.quantityAvailable ?? component?.productVariant?.quantityAvailable ?? 0
              : availability?.quantityAvailable || 0
          ));

          return {
            available: (isOnline || Boolean(availability?.available)) && quantityAvailable >= requiredQuantity,
            quantity: Math.floor(quantityAvailable / requiredQuantity),
          };
        });

        return {
          available: componentStates.length === components.length && componentStates.every((state) => state.available),
          quantity: componentStates.length ? Math.min(...componentStates.map((state) => state.quantity)) : 0,
          isBundle: true,
        };
      }

      const availability = item?.storeAvailability?.nodes?.find(
        (node) => node?.location?.name === storeName
      );
      const isOnline = storeName === "Shop Santé Inc.";
      const quantity = Math.max(0, Number(
        isOnline
          ? availability?.quantityAvailable ?? item?.quantityAvailable ?? 0
          : availability?.quantityAvailable || 0
      ));

      return {
        available: isOnline
          ? inventoryPolicy === "continue" || quantity > 0
          : Boolean(availability?.available) && quantity > 0,
        quantity,
        isBundle: false,
      };
    }
    async getVariantData() {
      let arrayVariants = JSON.parse(
        this.querySelector("[data-js-variants-data]").textContent
      );
      const arrayVariantsLocation = this.locationProduct?.data;

      if (!arrayVariantsLocation?.product?.variants?.nodes) {
        this.variantData = arrayVariants;
        return;
      }

      const inventory_policies = this.getInventoryPolicies();

      const variantIds = new Map();
      const storeName = await this.getStoreName();

      if (this.isLinkedBundle()) {
        const locationVariants = arrayVariantsLocation.product.variants.nodes;
        const requiredQuantity = this.getLinkedBundleQuantity();
        const allOriginVariantsAvailable = locationVariants.length === arrayVariants.length
          && locationVariants.every((item) => item.currentlyNotInStock
            || Math.floor(Math.max(0, Number(item.quantityAvailable || 0)) / requiredQuantity) > 0);
        arrayVariants.forEach((variant) => {
          const item = this.findLocationVariant(variant, locationVariants);
          const state = item
            ? this.getLinkedBundleState(item, storeName)
            : { available: allOriginVariantsAvailable, quantity: 0, isBundle: true };
          variantIds.set(
            Number(variant.id),
            item ? state.available : allOriginVariantsAvailable
          );
        });
      } else {
        arrayVariantsLocation.product.variants.nodes.forEach((item) => {
          const parsedId = item.id.split("gid://shopify/ProductVariant/")[1];

          const inventory_policy = inventory_policies.find(
            (policy) => Number(policy.id) === Number(parsedId)
          )?.inventory;
          const state = this.getLocationState(item, storeName, inventory_policy);
          variantIds.set(Number(parsedId), state.available);
        });
      }

      arrayVariants = arrayVariants.map((v) => {
        if (variantIds.has(v.id)) {
          v.available = variantIds.get(v.id);
        }
        return v;
      });
      this.variantData = arrayVariants;
    }
    checkBtnAddToCart() {
      if (this.productForm) {
        if (!this.currentVariant || !this.currentVariant.available) {
          if (this.productQty) this.productQty.style.display = "none";
          this.addToCart?.classList.add("disabled");
		  if (this.addToCart) this.addToCart.disabled = true;
		  this.addToCart?.setAttribute("aria-disabled", "true");
          this.productForm.classList.add("disabled-cart");
          if (this.addToCartText) {
            this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant;
          }
        } else {
          if (this.productQty) this.productQty.style.display = "";
          this.addToCart?.classList.remove("disabled");
		  if (this.addToCart) this.addToCart.disabled = false;
		  this.addToCart?.setAttribute("aria-disabled", "false");
          this.productForm.classList.remove("disabled-cart");
          if (this.addToCartText) {
            this.addToCartText.textContent = this.hasAttribute(
              "data-show-bundle-wording"
            )
              ? KROWN.settings.locales.products_add_to_bundle_button
              : KROWN.settings.locales.products_add_to_cart_button;
          }
        }
        if (!this.currentVariant) {
          this.productForm.classList.add("unavailable-variant");
          if (this.addToCartText) {
            this.addToCartText.textContent =
              this.variantRequired && this.noVariantSelectedYet
                ? KROWN.settings.locales.products_variant_required
                : KROWN.settings.locales.products_unavailable_variant;
          }
        } else {
          this.productForm.classList.remove("unavailable-variant");
        }
      }
    }
    async onVariantChange() {
      await this.getStoreName();
      await this.getVariantData();
      this.updateOptions();
      this.updateMasterId();
      const autoSelectedAvailableVariant = this.selectFirstAvailableVariant();
      if (autoSelectedAvailableVariant) {
        this.updateOptions();
        this.updateMasterId();
      }
      this.updateVariantInput();
      if (this.currentVariant) {
        this.getQuantityLocation(this.currentVariant.id);
      }
      if (this.price) {
        this.updatePrice();
      }
      this.updatePickupAvailabilityEachStore();
      this.updateStock();
      this.updateUnavailableVariants();
      this.updatePickupAvailability();
      if (!this.hasAttribute("data-no-history")) {
        this.updateURL();
      }
      this.updatePhotoMetafields();
      this.updateDetails();
      this.checkBtnAddToCart();
      this.dispatchEvent(new Event("VARIANT_CHANGE"));
    }
    updatePhotoMetafields() {
      if (!this.currentVariant) return;

      const scope = this.closest("product-page, #product-quick-view") || document;
      const metafieldData = scope.querySelector("[data-js-variant-metafield]");
      const image = scope.querySelector("[data-js-nutrition_facts]");
      if (!metafieldData || !image) return;

      let arrayVariantsMetafields;
      try {
        arrayVariantsMetafields = JSON.parse(metafieldData.textContent || "[]");
      } catch (error) {
        return;
      }

      const imgDefault = image.textContent.trim();
      const variantMetafieldImage = arrayVariantsMetafields.find(
        (item) => Number(item.id) === Number(this.currentVariant.id)
      );
      if (!variantMetafieldImage) return;

      const imgInfo = scope.querySelector("toggle-tab img");
      if (imgInfo != null) {
        if (variantMetafieldImage.image != "undefined") {
          imgInfo.srcset = variantMetafieldImage.image;
          imgInfo.src = variantMetafieldImage.image;
        } else {
          imgInfo.srcset = imgDefault;
          imgInfo.src = imgDefault;
        }
        imgInfo.closest("figure")?.querySelector(".img-magnifier-glass")?.remove();
        if (typeof window.magnify === "function") window.magnify("img-magnifier", 3);
      }
    }
    updateOptions() {
      this.options = [];

      this.querySelectorAll("[data-js-product-variant-container]").forEach(
        (elm) => {
          if (elm.dataset.jsProductVariantContainer == "radio") {
            elm.querySelectorAll(".product-variant__input").forEach((el) => {
              if (el.checked) {
                this.options.push(el.value);
              }
            });
          } else {
            if (!(this.variantRequired && elm.selectedIndex == 0)) {
              this.options.push(elm.value);
            }
          }
        }
      );

      if (
        this.variantRequired &&
        this.noVariantSelectedYet &&
        this.options.length >= parseInt(this.dataset.variants)
      ) {
        this.noVariantSelectedYet = false;
      }
    }
    async updateMasterId() {

      this.currentVariant = this.variantData.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    selectFirstAvailableVariant() {
      if (
        (this.variantRequired && this.noVariantSelectedYet) ||
        this.currentVariant?.available
      ) {
        return false;
      }

      const firstAvailableVariant = this.variantData.find(
        (variant) => variant.available
      );

      if (!firstAvailableVariant) {
        return false;
      }

      const optionContainers = this.querySelectorAll(
        "[data-js-product-variant-container]"
      );

      firstAvailableVariant.options.forEach((option, index) => {
        const container = optionContainers[index];
        if (!container) return;

        if (container.dataset.jsProductVariantContainer === "radio") {
          const input = Array.from(
            container.querySelectorAll(".product-variant__input")
          ).find((item) => item.value === option);

          if (input) input.checked = true;
          return;
        }

        container.value = option;

        const selector = container.closest("product-variant-selector");
        if (!selector) return;

        const selectedItem = Array.from(
          selector.querySelectorAll(".product-variant-value")
        ).find((item) => item.dataset.variantValue === option);

        selector
          .querySelectorAll(".product-variant-value")
          .forEach((item) => item.classList.remove("selected"));

        if (selectedItem) {
          selectedItem.classList.add("selected");
          const title = selector.querySelector("[data-variant-title]");
          const label = selector.querySelector("[data-variant-label]");

          if (title) {
            title.textContent = selectedItem.dataset.variantTitle || option;
          }
          if (label) {
            label.textContent = selectedItem.dataset.variantLabel || "";
          }
        }
      });

      this.options = [...firstAvailableVariant.options];
      this.currentVariant = firstAvailableVariant;

      return true;
    }

    updatePrice() {
      if (!this.currentVariant) {
        if (!(this.variantRequired && this.noVariantSelectedYet)) {
          if (this.priceOriginal) this.priceOriginal.innerHTML = "";
          if (this.priceCompare) this.priceCompare.innerHTML = "";
          if (this.priceUnit) this.priceUnit.innerHTML = "";
          if (this.priceSaving) {
            this.priceSaving.textContent = "";
            this.priceSaving.hidden = true;
          }
        }
      } else {
        if (this.priceOriginal) {
          this.priceOriginal.innerHTML = this._formatMoney(
            this.currentVariant.price,
            KROWN.settings.shop_money_format
          );
        }
        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          if (this.priceCompare) {
            this.priceCompare.innerHTML = this._formatMoney(
              this.currentVariant.compare_at_price,
              KROWN.settings.shop_money_format
            );
          }
          if (this.priceSaving) {
            this.priceSaving.textContent = `-${Math.round(
              Math.abs(
                (this.currentVariant.price * 100) /
                  this.currentVariant.compare_at_price -
                  100
              )
            )}%`;
            this.priceSaving.hidden = false;
          }
        } else {
          if (this.priceCompare) this.priceCompare.innerHTML = "";
          if (this.priceSaving) {
            this.priceSaving.textContent = "";
            this.priceSaving.hidden = true;
          }
        }

        if (this.currentVariant.unit_price_measurement) {
          if (this.priceUnit) this.priceUnit.innerHTML = `
						${this._formatMoney(
              this.currentVariant.unit_price,
              KROWN.settings.shop_money_format
            )} /
						${
              this.currentVariant.unit_price_measurement.reference_value != 1
                ? this.currentVariant.unit_price_measurement.reference_value +
                  " "
                : ""
            }
						${this.currentVariant.unit_price_measurement.reference_unit}
					`;
        } else {
          if (this.priceUnit) this.priceUnit.innerHTML = "";
        }
      }
    }

    updateStock() {
      if (!this.currentVariant) {
        if (this.productStock) {
          this.productStock.innerHTML = "";
        }
      } else {
        if (this.productStock && this.productStockData) {
          let currentVariant = false;
          for (const variant of this.productStockData) {
            if (variant.id == this.currentVariant.id) {
              currentVariant = variant;
              break;
            }
          }
          this.productStock.innerHTML = "";

          if (currentVariant) {
            if (currentVariant.inventory == "continue") {
              this.productStock.innerHTML = KROWN.settings.locales.in_stock;
            } else if (currentVariant.quantity <= 0) {
              if (currentVariant.inventory == "deny") {
                this.productStock.innerHTML =
                  KROWN.settings.locales.products_no_products;
              }
            } else if (currentVariant.quantity == "1") {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_one_product;
            } else if (
              currentVariant.quantity <=
              parseInt(this.productStock.dataset.lowStock)
            ) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_few_products.replace(
                  "{{ count }}",
                  currentVariant.quantity
                );
            } else if (currentVariant.unavailable) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_no_products;
            } else if (
              currentVariant.quantity >
                parseInt(this.productStock.dataset.lowStock) &&
              this.productStock.dataset.type == "always"
            ) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_few_products.replace(
                  "{{ count }}",
                  currentVariant.quantity
                );
            } else if (!currentVariant.quantity) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_enough_products;
            }

            if (this.productStockProgress) {
              let progressQty = 0;
              if (
                (currentVariant.quantity <= 0 &&
                  currentVariant.inventory == "continue") ||
                typeof currentVariant.quantity === "undefined"
              ) {
                progressQty = parseInt(this.productStock.dataset.highStock);
              } else if (currentVariant.quantity > 0) {
                progressQty = currentVariant.quantity;
              }
              if (
                progressQty >= parseInt(this.productStock.dataset.highStock)
              ) {
                this.productStockProgress.style.width = `100%`;
              } else {
                this.productStockProgress.style.width = `${
                  (100 * progressQty) /
                  parseInt(this.productStock.dataset.highStock)
                }%`;
              }
            }
          }
        }
      }
    }

    updateDetails() {
      document
        .querySelectorAll(`#product-${this.dataset.id} [data-js-product-sku]`)
        .forEach((elm) => {
          if (this.currentVariant && this.currentVariant.sku) {
            elm.innerHTML =
              KROWN.settings.locales.product_sku + this.currentVariant.sku;
          } else {
            elm.innerHTML = "";
          }
        });

      document
        .querySelectorAll(
          `#product-${this.dataset.id} [data-js-product-barcode]`
        )
        .forEach((elm) => {
          if (this.currentVariant && this.currentVariant.barcode) {
            elm.innerHTML =
              KROWN.settings.locales.product_barcode +
              this.currentVariant.barcode;
          } else {
            elm.innerHTML = "";
          }
        });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector("pickup-availability");
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    updatePickupAvailabilityEachStore() {
      if (!this.locationProduct?.data?.product?.variants?.nodes) return;
      if (!this.currentVariant) return;

      const allStores = document.querySelectorAll(
        ".store-selector-item[data-title]"
      );

      const variantsLocation = this.findLocationVariant(
        this.currentVariant,
        this.locationProduct.data.product.variants.nodes
      );

      if (!variantsLocation) return;

      allStores.forEach((store) => {
        const itemName = store.getAttribute("data-title");
        const itemAvailable = store.querySelector(
          ".store-selector-item__available"
        );

        if (!itemAvailable) return;

        const inventory_policy = this.isLinkedBundle()
          ? "deny"
          : this.getInventoryPolicies().find(
              (policy) => Number(policy.id) === Number(this.currentVariant.id)
            )?.inventory;
        const state = this.isLinkedBundle()
          ? this.getLinkedBundleState(variantsLocation, itemName)
          : this.getLocationState(variantsLocation, itemName, inventory_policy);

        itemAvailable.classList.toggle("alert--success", state.available);
        itemAvailable.classList.toggle("alert--error", !state.available);
      });
    }

    updateUnavailableVariants() {
      if (this.dataset.hideVariants != "false") {
        let options1 = {},
          options2 = {},
          options3 = {},
          option1Selected = null,
          option2Selected = null;

        if (this.dataset.variants > 0) {
          option1Selected = this._getSelectedOption(0);
          this._resetDisabledOption(0);
        }
        if (this.dataset.variants > 1) {
          option2Selected = this._getSelectedOption(1);
          this._resetDisabledOption(1);
        }

        this.variantData.forEach((el) => {
          if (this.dataset.variants > 0) {
            if (!options1[el.option1]) {
              options1[el.option1] = [];
            }
            options1[el.option1].push(String(el.available));
          }
          if (this.dataset.variants > 1) {
            if (!options2[el.option2]) {
              options2[el.option2] = [];
            }
            options2[el.option2].push(String(el.available));
          }
          if (this.dataset.variants == 2) {
            if (el.option1 == option1Selected && !el.available) {
              this._setDisabledOption(1, el.option2);
            }
          }
          if (this.dataset.variants > 2) {
            if (!options3[el.option3]) {
              options3[el.option3] = [];
            }
            options3[el.option3].push(String(el.available));
            if (
              el.option2 == option2Selected &&
              el.option1 == option1Selected &&
              !el.available
            ) {
              this._setDisabledOption(2, el.option3);
            }
          }
        });

        if (this.dataset.variants > 0) {
          Object.keys(options1).forEach((key) => {
            if (!options1[key].includes("true")) {
              this._setDisabledOption(0, key);
            }
          });
        }
        if (this.dataset.variants > 1) {
          Object.keys(options2).forEach((key) => {
            if (!options2[key].includes("true")) {
              this._setDisabledOption(1, key);
            }
          });
        }
        if (this.dataset.variants > 2) {
          Object.keys(options3).forEach((key) => {
            if (!options3[key].includes("true")) {
              this._setDisabledOption(2, key);
            }
          });
          Object.keys(options2).forEach((key) => {
            if (!options2[key].includes("true")) {
              if (option2Selected == key) {
                if (this.dataset.hideVariants == "disable") {
                  this.querySelectorAll("[data-js-product-variant]")[2]
                    .querySelector(".product-variant-value")
                    .setAttribute("disabled", "disabled");
                } else {
                  this.querySelectorAll("[data-js-product-variant]")[2]
                    .querySelector(".product-variant-value")
                    .classList.add("disabled");
                }
              }
            }
          });
        }
      }
    }

    _getSelectedOption(i) {
      let selectedOption = null;
      this.querySelectorAll("[data-js-product-variant]")
        [i].querySelectorAll("[data-js-product-variant-container]")
        .forEach((elm) => {
          if (elm.dataset.jsProductVariantContainer == "radio") {
            elm.querySelectorAll(".product-variant__input").forEach((el) => {
              if (el.checked) {
                selectedOption = el.value;
              }
            });
          } else {
            selectedOption = elm.value;
          }
        });
      return selectedOption;
    }

    _resetDisabledOption(i) {
      this.querySelectorAll("[data-js-product-variant]")
        [i].querySelectorAll(".product-variant-value")
        .forEach((elm) => {
          elm.classList.remove("disabled");
          elm.classList.remove("hide-variant");
          elm.hidden = false;
          if (!elm.hasAttribute("default")) {
            elm.removeAttribute("disabled");
          }
          if (elm.parentNode) {
            elm.parentNode.classList.remove("hide-variant");
            elm.parentNode.hidden = false;
          }
        });

      this.querySelectorAll("[data-js-product-variant]")
        [i].querySelectorAll("option")
        .forEach((option) => {
          option.disabled = false;
          option.hidden = false;
        });
    }

    _setDisabledOption(i, option) {
      const variantGroup = this.querySelectorAll("[data-js-product-variant]")[i];
      if (!variantGroup) return;

      const escapedOption = option.replace('"', "&x22;");
      let variant = variantGroup.querySelector(
        `.product-variant-value[value="${escapedOption}"]`
      );

      const nativeOption = Array.from(variantGroup.querySelectorAll("option"))
        .find((item) => item.value === option);

      if (nativeOption) {
        nativeOption.disabled = true;
        nativeOption.hidden = false;
      }

      if (variant) {
        variant.setAttribute("disabled", "disabled");
        variant.classList.add("disabled");
        variant.classList.remove("hide-variant");
        variant.hidden = false;

        if (variant.parentNode) {
          variant.parentNode.classList.remove("hide-variant");
          variant.parentNode.hidden = false;
        }
      }
    }

    updateURL() {
      if (!this.currentVariant) return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
    getQuantityLocation(activeId) {
      const variants = this.locationProduct?.data?.product?.variants?.nodes;
      if (!variants) return;

      const localVariant = this.variantData.find((variant) => Number(variant.id) === Number(activeId));
      const activeItem = this.findLocationVariant(localVariant, variants);
      if (!activeItem) return;

      const inventoryPolicy = this.isLinkedBundle()
        ? "deny"
        : this.getInventoryPolicies().find((policy) =>
            Number(policy.id) === Number(activeId)
          )?.inventory;
      const state = this.isLinkedBundle()
        ? this.getLinkedBundleState(activeItem, this.storeLocationName)
        : this.getLocationState(activeItem, this.storeLocationName, inventoryPolicy);
      const canOversellOnline = this.storeLocationName === "Shop Santé Inc."
        && inventoryPolicy === "continue"
        && !state.isBundle;
      const limit = canOversellOnline ? 9999 : state.quantity;
      const productForm = this.productForm || this.closest("product-page")?.querySelector('form[action*="/cart/add"]');

      productForm?.setAttribute("data-limit-location", String(limit));
      this.closest("product-page")?.querySelector('[data-js-product-form]')
        ?.setAttribute("data-limit-location", String(limit));

      const quantityPlus = productForm?.querySelector(".qty-plus, .product-quantity__plus");
      const currentQuantityInput = productForm?.querySelector(".qty-selector, .product-quantity__selector");

      if (quantityPlus && currentQuantityInput) {
        const currentValue = Math.max(1, Number(currentQuantityInput.value || 1));
        if (!canOversellOnline && (limit <= 0 || currentValue >= limit)) {
          quantityPlus.classList.add("disabled");
          if (limit > 0 && currentValue > limit) currentQuantityInput.value = String(limit);
        } else {
          quantityPlus.classList.remove("disabled");
        }
      }

      return state.quantity;
    }
    updateVariantInput() {
      if (!this.currentVariant) return;
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.id}, #product-form-installment`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get("product-variants") == "undefined") {
    customElements.define("product-variants", ProductVariants);
  }
}

/* ---
	Product Form
--- */

if (typeof ProductForm !== "function") {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      if (this.hasAttribute("data-ajax-cart")) {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.ADD_TO_CART = new Event("add-to-cart");
      }
    }

    async onSubmitHandler(e) {
      e.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton || submitButton.disabled) return;
      submitButton.classList.add("working");
      submitButton.setAttribute("aria-busy", "true");

      const showAlert = (message) => {
        this.querySelector(".alert--error")?.remove();
        const alert = document.createElement("span");
        alert.style.margin = "0 auto";
        alert.className = "alert alert--error";
        alert.setAttribute("role", "alert");
        alert.textContent = message || KROWN.settings.locales.cart_general_error;
        this.append(alert);
      };

      try {
        const addResponse = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
          body: this._serializeForm(this.form),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
          method: "POST",
        });
        const addResult = await addResponse.json();

        if (!addResponse.ok || addResult.status === 422) {
          showAlert(addResult.description || addResult.message);
          return;
        }

        const isCosties = Boolean(
          window.ShopSanteCustomer?.isLoggedIn &&
          window.ShopSanteCustomer?.isCosties
        );

        if (isCosties) {
          const desiredBlockValue = window.COSTIES_CUSTOMER_ONLINE_ALLOWED
            ? "false"
            : "true";
          const cartResponse = await fetch(`${KROWN.settings.routes.cart_url}.js`, {
            headers: { "Accept": "application/json" },
          });
          const cart = await cartResponse.json();

          if (cart.attributes?.costies_block_online !== desiredBlockValue) {
            await fetch(`${KROWN.settings.routes.cart_url.replace('/cart', '/cart/update')}.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({
                attributes: {
                  ...(cart.attributes || {}),
                  costies_block_online: desiredBlockValue,
                },
              }),
            });
          }
        }

        if (typeof window.ShopSanteRefreshCart === "function") {
          await window.ShopSanteRefreshCart();
        } else {
          const sectionUrl = new URL(window.location.pathname, window.location.origin);
          sectionUrl.searchParams.set("section_id", "helper-cart");
          const sectionResponse = await fetch(sectionUrl.toString(), {
            headers: { "X-Requested-With": "XMLHttpRequest" },
          });
          const text = await sectionResponse.text();
          const sectionDocument = new DOMParser().parseFromString(text, "text/html");
          const newCartForm = sectionDocument.getElementById("AjaxCartForm");
          const newCartSubtotal = sectionDocument.getElementById("AjaxCartSubtotal");
          const cartItems = document.getElementById("AjaxCartForm");
          const cartSubtotal = document.getElementById("AjaxCartSubtotal");

          if (!newCartForm || !newCartSubtotal || !cartItems || !cartSubtotal) {
            throw new Error("Unable to refresh cart");
          }

          cartItems.innerHTML = newCartForm.innerHTML;
          cartItems.ajaxifyCartItems?.();
          cartSubtotal.innerHTML = newCartSubtotal.innerHTML;

          document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
            const count = cartItems.querySelector("[data-cart-count]");
            if (count) elm.textContent = count.textContent;
          });
          document.querySelectorAll("[data-header-cart-total]").forEach((elm) => {
            const total = cartItems.querySelector("[data-cart-total]");
            if (total) elm.textContent = total.textContent;
          });
          if (typeof window.InitSubmit === "function") window.InitSubmit();
        }

        this.dispatchEvent(this.ADD_TO_CART);
      } catch (error) {
        console.error("Unable to add product to cart", error);
        showAlert(KROWN.settings.locales.cart_general_error);
      } finally {
        submitButton.classList.remove("working");
        submitButton.removeAttribute("aria-busy");
      }
    }

    _serializeForm(form) {
      let arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
        )
          return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                "=" +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
        );
      });
      return arr.join("&");
    }
  }

  if (typeof customElements.get("product-form") == "undefined") {
    customElements.define("product-form", ProductForm);
  }
}

/* ---
	Product Recommendations
--- */

if (typeof ProductRecommendations !== "function") {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const event = new Event("product-recommendations-loaded");

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const innerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector("product-recommendations");

            if (
              innerHTML &&
              innerHTML.querySelectorAll("[data-js-product-item]").length > 0
            ) {
              this.innerHTML = innerHTML.innerHTML;
              this.querySelectorAll("form").forEach((elm) => {
                if (elm.querySelector("template")) {
                  elm.append(
                    elm.querySelector("template").content.cloneNode(true)
                  );
                }
              });
              this.dispatchEvent(event);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: `0px 0px 400px 0px`,
      }).observe(this);
    }
  }

  if (typeof customElements.get("product-recommendations") == "undefined") {
    customElements.define("product-recommendations", ProductRecommendations);
  }
}

if (typeof ProductVariantSelector !== "function") {
  class ProductVariantSelector extends HTMLElement {
    constructor() {
      super();
      if (this.querySelector("details")) {
        this.init();
      }
    }
    init() {
      const select = this.querySelector("select");
      const details = this.querySelector("details");
      details.addEventListener("click", (event) => {
        const item = event.target.closest("li");
        if (item) {
          if (item.hidden || item.classList.contains("disabled") || item.classList.contains("hide-variant") || item.hasAttribute("disabled")) {
            event.preventDefault();
            return;
          }
          const value = item.getAttribute("data-variant-value");
          const label = item.getAttribute("data-variant-label");
          const title = item.getAttribute("data-variant-title");
          this.querySelector("summary [data-variant-title]").textContent =
            title;
          this.querySelector("summary [data-variant-label]").textContent =
            label;

          const items = details.querySelectorAll("ul > li");

          items.forEach((item) => {
            item.classList.remove("selected");
          });
          item.classList.add("selected");

          if (select) {
            const event = new Event("change", {
              view: window,
              bubbles: true,
              cancelable: true,
            });
            select.value = value;
            select.dispatchEvent(event);
          }
          details.open = false;
          this.dispatchEvent(
            new CustomEvent("product-variant-selector:changed", {
              bubbles: true,
              detail: { value },
            })
          );
        }
      });
      document.addEventListener("click", (event) => {
        if (!details.contains(event.target) && details.open) {
          details.open = false;
        }
      });
    }
  }

  if (typeof customElements.get("product-variant-selector") == "undefined") {
    customElements.define("product-variant-selector", ProductVariantSelector);
  }
}
